export default __webpack_public_path__ + "static/media/img_baseCrochetRattle_lemon_p.8e508e2f.jpg";